import { useEffect } from 'react';

function FullPageLoader() {

  useEffect(() => {
    // Scroll lock (taaki user peeche scroll na kare)
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className="fixed z-[9999] top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm transition-all duration-300">
      
      <div className="flex items-center justify-center gap-3 mb-6">  
          <img src="/logo.svg" alt="UpTrend Logo" className="w-10 h-10" />
          <h1 className="text-3xl font-bold text-gray-800 tracking-tight">
            UpTrend
          </h1>
      </div>

      <div className="relative w-12 h-12">
         <div className="absolute top-0 left-0 w-full h-full border-4 border-indigo-100 rounded-full"></div>
         <div className="absolute top-0 left-0 w-full h-full border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
      </div>
      
    </div>
  );
}

export default FullPageLoader;